// extracted by mini-css-extract-plugin
export default {"anonymousLayoutContainer":"AnonymousLayout_anonymousLayoutContainer__WIJIb"};